import { NavLink } from "react-router-dom";
import { 
  LayoutDashboard, Users, MapPin, Star, BookText, MessageSquare, 
  Mail, LogOut, Route, UserCog, BrainCircuit, Newspaper, 
  FileCheck, PieChart, ChevronRight, Coins
} from "lucide-react";

// Menüleri mantıksal gruplara ayırıyoruz
const menuGroups = [
  {
    title: "Genel",
    items: [
      { name: "Dashboard", path: "/admin/dashboard", icon: LayoutDashboard },
      { name: "Tahmin Raporları", path: "/admin/report", icon: PieChart },
      { name: "Tüm Raporlar", path: "/admin/reports", icon: PieChart },
    ]
  },
  {
    title: "İçerik Yönetimi",
    items: [
      { name: "Mekanlar(Keşfet)", path: "/admin/places", icon: MapPin },
      { name: "Mekanlar(Mekânname AI)", path: "/admin/places-ai", icon: MapPin },
      { name: "Rotalar", path: "/admin/routesAdmin", icon: Route },
      { name: "Blog Yazıları", path: "/admin/blog", icon: Newspaper },
      { name: "Quizler", path: "/admin/quizAdd", icon: BrainCircuit },
      { name: "Anlatımlar", path: "/admin/narrations", icon: BookText },
      { name: "Token Yönetimi", path: "/admin/token", icon: Coins},
      { name: "Paket Yönetimi", path: "/admin/user-packages", icon: Coins},
    ]
  },
  {
    title: "Kullanıcı & Etkileşim",
    items: [
      { name: "Kullanıcılar", path: "/admin/users", icon: Users },
      { name: "Editörler", path: "/admin/editor", icon: UserCog },
      { name: "Başvurular", path: "/admin/application", icon: FileCheck },
      { name: "Yorumlar", path: "/admin/comments", icon: MessageSquare },
      { name: "Mesajlar", path: "/admin/messages", icon: Mail },
      { name: "Tahminler", path: "/admin/predictions", icon: Star },
      { name: "Onay", path: "/admin/approval", icon: Star },
    ]
  }
];

export default function Sidebar() {
  return (
    <>
      {/* --- SCROLLBAR CSS --- */}
      {/* Bu stili global css dosyanıza (index.css) taşımanız daha iyi olur */}
      <style>{`
        .custom-scrollbar::-webkit-scrollbar {
          width: 5px; /* İnce scrollbar */
        }
        .custom-scrollbar::-webkit-scrollbar-track {
          background: transparent; /* Arka plan şeffaf */
        }
        .custom-scrollbar::-webkit-scrollbar-thumb {
          background-color: #334155; /* Slate-700 rengi (Koyu gri) */
          border-radius: 20px; /* Yuvarlak köşeler */
        }
        .custom-scrollbar::-webkit-scrollbar-thumb:hover {
          background-color: #475569; /* Hover olunca biraz açılır (Slate-600) */
        }
        /* Firefox Desteği */
        .custom-scrollbar {
          scrollbar-width: thin;
          scrollbar-color: #334155 transparent;
        }
      `}</style>

      <aside className="w-72 bg-[#0f172a] text-gray-300 min-h-screen flex flex-col border-r border-gray-800 shadow-xl">
        
        {/* --- LOGO ALANI --- */}
        <div className="h-20 flex items-center gap-3 px-6 border-b border-gray-800/50 bg-[#0f172a]/50 backdrop-blur-sm sticky top-0 z-10">
          <div className="p-2 bg-indigo-600 rounded-lg shadow-lg shadow-indigo-500/30">
            <MapPin className="h-6 w-6 text-white" />
          </div>
          <div>
            <h2 className="text-xl font-bold text-white tracking-tight">Mekânname</h2>
            <span className="text-xs text-indigo-400 font-medium tracking-wide">YÖNETİM PANELİ</span>
          </div>
        </div>

        {/* --- SCROLLABLE MENÜ ALANI --- */}
        {/* 'overflow-hidden' kaldırıldı, yerine 'custom-scrollbar' eklendi */}
        <nav className="flex-1 overflow-y-auto overflow-x-hidden py-6 px-4 space-y-8 custom-scrollbar">
          {menuGroups.map((group, groupIndex) => (
            <div key={groupIndex}>
              {/* Grup Başlığı */}
              <h3 className="px-4 text-xs font-bold text-gray-500 uppercase tracking-wider mb-3">
                {group.title}
              </h3>
              
              {/* Grup Linkleri */}
              <div className="space-y-1">
                {group.items.map(({ name, path, icon: Icon }) => (
                  <NavLink
                    key={path}
                    to={path}
                    className={({ isActive }) =>
                      `relative flex items-center justify-between py-2.5 px-4 rounded-xl transition-all duration-200 group
                      ${isActive 
                        ? "bg-indigo-600 text-white shadow-md shadow-indigo-900/20" 
                        : "text-gray-400 hover:bg-gray-800 hover:text-gray-100"
                      }`
                    }
                  >
                    {({ isActive }) => (
                      <>
                        <div className="flex items-center gap-3">
                          <Icon className={`h-5 w-5 transition-colors ${isActive ? 'text-white' : 'text-gray-500 group-hover:text-gray-300'}`} />
                          <span className="font-medium text-sm">{name}</span>
                        </div>
                        {/* Aktif İndikatörü */}
                        {isActive && <ChevronRight className="h-4 w-4 text-indigo-200" />}
                      </>
                    )}
                  </NavLink>
                ))}
              </div>
            </div>
          ))}
        </nav>
        
        {/* --- ALT FOOTER (ÇIKIŞ) --- */}
        <div className="p-4 border-t border-gray-800 bg-[#0f172a]">
          <NavLink
            to="/"
            className="flex items-center gap-3 py-3 px-4 rounded-xl transition-all duration-200 text-red-400 hover:bg-red-500/10 hover:text-red-300 group"
          >
            <LogOut className="h-5 w-5 transition-transform group-hover:-translate-x-1" />
            <span className="font-medium">Çıkış Yap</span>
          </NavLink>
        </div>
      </aside>
    </>
  );
}